import Swiper from "swiper";
import { Controller, Autoplay, EffectCards, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-cards";
import "swiper/css/effect-fade";

class ProductCarousel extends HTMLElement {
  constructor() {
    super();

    this.swiperMain = null;
    this.swiperController = null;

    this.swiperMainSlides = [];
  }

  handleSlideOpacity = (realIndex) => {
    const range = 1; // Number of neighboring slides with partial opacity
    const totalSlides = this.swiperMainSlides.length;

    this.swiperMainSlides.forEach((slide) => {
      const slideInner = slide.querySelector(".slide__inner");
      const swiperSlide = slide.closest(".swiper-slide");
      const slideIndex = parseInt(
        slide.getAttribute("data-swiper-slide-index"),
        10
      );

      // Calculate the shortest distance between realIndex and slideIndex, considering wrap-around
      const distance = this.calculateDistance(
        realIndex,
        slideIndex,
        totalSlides
      );

      // Determine opacity based on distance
      const opacity = this.getOpacity(distance, range);

      // Update slide classes and styles
      this.updateSlide(swiperSlide, slideInner, opacity, distance);
    });
  };

  // Helper function to calculate the shortest distance
  calculateDistance = (realIndex, slideIndex, totalSlides) => {
    return Math.min(
      Math.abs(realIndex - slideIndex),
      totalSlides - Math.abs(realIndex - slideIndex)
    );
  };

  // Helper function to determine opacity based on distance
  getOpacity = (distance, range) => {
    if (distance === 0) return 1;
    if (distance <= range) return 0.5;
    return 0;
  };

  // Helper function to update slide classes and styles
  updateSlide = (swiperSlide, slideInner, opacity, distance) => {
    if (swiperSlide) {
      if (distance === 0 || distance <= 1) {
        swiperSlide.classList.remove("--no-drag");
      } else {
        swiperSlide.classList.add("--no-drag");
      }
    }

    if (slideInner) {
      slideInner.style.setProperty("--opacity", opacity);
    }
  };

  setup() {
    document.addEventListener("DOMContentLoaded", () => {
      this.swiperMain = new Swiper(this.querySelector(".swiper.swiper--main"), {
        modules: [Autoplay, Controller, EffectCards],
        navigation: {
          nextEl: ".swiper-wrapper .swiper-button-next",
          prevEl: ".swiper-wrapper .swiper-button-prev",
        },
        centeredSlides: true,
        loop: true,
        slidesPerView: 1,
        effect: "cards",
        cardsEffect: {
          perSlideOffset: 24,
          rotate: false,
        },
        grabCursor: true,
        breakpoints: {
          768: {
            cardsEffect: {
              perSlideOffset: 32,
            },
          },
          1024: {
            cardsEffect: {
              perSlideOffset: 48,
            },
          },
        },
        on: {
          init: (event) => {
            this.swiperMainSlides = event.slides;
            this.handleSlideOpacity(0);
          },

          slideChange: (event) => {
            this.handleSlideOpacity(event.realIndex);
          },
        },
      });

      this.swiperDetails = new Swiper(
        this.querySelector(".swiper.swiper--details"),
        {
          modules: [EffectFade],
          centeredSlides: true,
          loop: true,
          slidesPerView: 1,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          allowTouchMove: false,
        }
      );

      this.swiperMain.controller.control = this.swiperDetails;
    });
  }

  connectedCallback() {
    this.setup();
  }
}

customElements.define("component-product-carousel", ProductCarousel);
